var OG_MESSAGE_BODY_CLASSNAME = 'sendbird-og-message-item-body__text-bubble';

export { OG_MESSAGE_BODY_CLASSNAME as O };
//# sourceMappingURL=bundle-DxT0jQsV.js.map
